import { ComponentList } from './ComponentList'
import { LandingPageProjectInfo } from '@models/projects.model'
import { Box, Typography, useMediaQuery } from '@mui/material'

interface PopoverContainerProps {
	markerElem: LandingPageProjectInfo
}

export const PopoverContainer = ({ markerElem }: PopoverContainerProps) => {
	const isSmallScreen = useMediaQuery('(max-width:1180px)')

	return (
		<Box
			sx={
				isSmallScreen
					? {
							width: '100%',
							minWidth: '300px',
							height: 550,
							padding: '15px 15px 5px 15px',
					  }
					: {
							width: '100%',
							height: 716,
							maxWidth: '500px',
							minWidth: '500px',
							padding: '15px 30px 5px 30px',
					  }
			}
			display="flex"
			flexDirection="column"
			alignItems="center"
		>
			<Typography
				variant={isSmallScreen ? 'h6' : 'h2'}
				color="white"
				marginBottom="5px"
				width="100%"
			>
				{markerElem['display_name']}
			</Typography>
			<ComponentList markerElem={markerElem} />
			{/* <ApplicationList /> */}
		</Box>
	)
}
